import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchTab} from "../types/SearchTab";
import {generateRegionsPillLabel, generateRegionsPillLabels} from "./generate_regions_pill_label";

interface IGeneratePillLabelOptions {
    hiddenRegionsLabelVariant?: "full" | "compact";
}

export const generatePillLabels = (searchFieldPropsValue: ISearchInputValue, options?: IGeneratePillLabelOptions): string[] => {
    if (searchFieldPropsValue.tabType === SearchTab.Regions && searchFieldPropsValue.regions) {
        return generateRegionsPillLabels(searchFieldPropsValue.regions, options);
    }

    return [];
};

export const generatePillLabel = (isDropdownOpen: boolean, searchFieldPropsValue: ISearchInputValue, options?: IGeneratePillLabelOptions): string | null => {
    if (searchFieldPropsValue.tabType === SearchTab.Regions && searchFieldPropsValue.regions) {
        return generateRegionsPillLabel(searchFieldPropsValue.regions, options);
    }
    return null;
};
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchTab} from "../types/SearchTab";
import {generateRegionsPillLabel, generateRegionsPillLabels} from "./generate_regions_pill_label";

interface IGeneratePillLabelOptions {
    hiddenRegionsLabelVariant?: "full" | "compact";
}

export const generatePillLabels = (searchFieldPropsValue: ISearchInputValue, options?: IGeneratePillLabelOptions): string[] => {
    if (searchFieldPropsValue.tabType === SearchTab.Regions && searchFieldPropsValue.regions) {
        return generateRegionsPillLabels(searchFieldPropsValue.regions, options);
    }

    return [];
};

export const generatePillLabel = (isDropdownOpen: boolean, searchFieldPropsValue: ISearchInputValue, options?: IGeneratePillLabelOptions): string | null => {
    if (searchFieldPropsValue.tabType === SearchTab.Regions && searchFieldPropsValue.regions) {
        return generateRegionsPillLabel(searchFieldPropsValue.regions, options);
    }
    return null;
};
